import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Box } from '@material-ui/core'
import Button from 'components/Button/Button'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import { useStyles } from './TechlinkApplyButton_style'

const TechlinkApplyButton = (props) => {
    const { job, containerClass, buttonVariant = 'primary', buttonSize = 'big' } = props
    const classes = useStyles()

    return (
        <Box className={containerClass && containerClass}>
            <RouteMapLink
                target='_blank'
                showItemType={job.type}
                showItemUrl={job.url}
                paramString='?process=apply'
            >
                <Button variant={buttonVariant} size={buttonSize} className={classes.button}>
                    <FormattedMessage id={job.application_url ? 'transl_internship.postulate_on_company_website' : 'transl_internship.postulate_button'} />
                </Button>
            </RouteMapLink>
        </Box>
    )
}

export default TechlinkApplyButton
